"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRO = exports.STARTER = exports.FEATURE_LIMIT_BADGE = void 0;
var FEATURE_LIMIT_BADGE = 'FeatureLimitBadge';
exports.FEATURE_LIMIT_BADGE = FEATURE_LIMIT_BADGE;
var STARTER = 'starter';
exports.STARTER = STARTER;
var PRO = 'pro';
exports.PRO = PRO;